import { IMAGES } from "@/lib/api";

const works = [
  ["The Sandstone Residence", "Japandi · 3 BHK · Bengaluru", IMAGES.japandi, "lg:col-span-7 aspect-[16/11]"],
  ["Oak & Linen Suite", "Warm Modern · Master Bedroom", IMAGES.bedroom2, "lg:col-span-5 aspect-[4/5]"],
  ["Ivory Kitchen", "Contemporary · Modular Kitchen", IMAGES.kitchen, "lg:col-span-5 aspect-[4/5]"],
  ["Courtyard Living", "Contemporary Luxury · 4 BHK", IMAGES.living, "lg:col-span-7 aspect-[16/11]"],
];

export default function Portfolio() {
  return (
    <section id="portfolio" className="py-20 lg:py-28 bg-brand-cream" data-testid="portfolio-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <p className="text-xs uppercase tracking-[0.25em] text-brand-accent">Portfolio</p>
        <h2 className="font-serif-display text-4xl lg:text-5xl text-brand-ink mt-4 max-w-xl">Homes that feel quietly considered.</h2>
        <div className="grid lg:grid-cols-12 gap-6 mt-14">
          {works.map(([t, s, img, cls]) => (
            <figure key={t} className={`group relative rounded-2xl overflow-hidden ${cls}`} data-testid={`portfolio-item-${t.replace(/\s|&/g, "-").toLowerCase()}`}>
              <img src={img} alt={t} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
              <figcaption className="absolute left-5 bottom-5 bg-brand-cream/90 backdrop-blur-md rounded-xl px-5 py-3">
                <p className="font-serif-display text-xl text-brand-ink">{t}</p>
                <p className="text-xs text-brand-muted">{s}</p>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
